import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AdminAuthProvider } from './context/AdminAuthContext';
import AdminProtectedRoute from './components/admin/AdminProtectedRoute';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './App.css';

// Pages
import HomePage from './components/Home/HomePage';
import FeaturesPage from './components/Home/FeaturesPage';
import HowItWorksPage from './components/Home/HowItWorksPage';
import FAQPage from './components/Home/FAQPage';
import TestsPage from './components/TestPage';
import LoginPage from './components/LoginPage';
import LoginAdminpage from './components/admin/AdminLoginPage';
import RegisterPage from './components/RegisterPage';
import Auth from './components/Auth';
import CertificatePage from './components/common/CertificatePage';
import Privacy from './components/PrivacyPage';
import Profile from './components/profliepaga';

// Dashboard Components
import DashboardLayout from './components/admin/DashboardLayout';
import DashboardHome from './components/admin/DashboardHome';
import UserTests from './components/admin/UserTests';
import UserResults from './components/admin/UserResults';
import UserProfile from './components/admin/UserProfile';
import UserSettings from './components/admin/UserSettings';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AdminAuthProvider>
          <Router>
            <Routes>

              {/* Public */}
              <Route path="/" element={<HomePage />} />
              <Route path="/features" element={<FeaturesPage />} />
              <Route path="/how-it-works" element={<HowItWorksPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/tests" element={<TestsPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/certificate/:testId" element={<CertificatePage />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/profile" element={<Profile />} />

              {/* Admin Login */}
              <Route path="/admin-23nafs-33/login" element={<LoginAdminpage />} />

              {/* Admin Dashboard - Protected */}
              <Route
                path="/admin-23nafs-33/dashboard/"
                element={
                  <AdminProtectedRoute>
                    <DashboardLayout adminMode={true} />
                  </AdminProtectedRoute>
                }
              >
                <Route index element={<DashboardHome adminMode={true} />} />
                <Route path="tests" element={<UserTests adminMode={true} />} />
                <Route path="results" element={<UserResults adminMode={true} />} />
                <Route path="profile" element={<UserProfile adminMode={true} />} />
                <Route path="settings" element={<UserSettings adminMode={true} />} />
              </Route>

              {/* ANY attempt to access /admin → redirect to admin login */}
              <Route path="/admin/*" element={<Navigate to="/admin-23nafs-33/login" replace />} />

            </Routes>
          </Router>
        </AdminAuthProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
